export const TEMPLATE_WEBMCP_LOG_PREFIX = '[Template WebMCP]';

/** Must match the CLI version in docs (`npx @mcp-b/webmcp-local-relay@…`). */
export const MCP_B_PACKAGE_VERSION = '5.1.0';

export const MCP_B_RELAY_EMBED_SCRIPT_ID = 'webmcp-local-relay-embed';

const CREATIVE_HUB_ORIGIN = String(process.env.VITE_BASE_URL ?? '').replace(/\/$/, '');

// Mirrored from @mcp-b/webmcp-local-relay dist/browser on postinstall
// (`pnpm webmcp:sync-embed`). Origin comes from VITE_BASE_URL so a federated
// shell still loads the script from Creative Hub, not jsDelivr. The filename and
// directory are fixed: embed.js fetches `widget.html` next to its own src.
export const MCP_B_RELAY_EMBED_SRC = `${CREATIVE_HUB_ORIGIN}/webmcp/embed.js`;
